// =============================================================================
// 1. ExtractBalancesButton.js
// src/components/RPA/buttons/ExtractBalancesButton.js
// =============================================================================
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function ExtractBalancesButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/balance-sheet/extract-balances`,
        {},
        { withCredentials: true }
      );
      
      console.log('[EXTRACT_BALANCES_BTN] Success:', res.data);
      if (onDone) onDone();
    } catch (err) {
      console.error('[EXTRACT_BALANCES_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Balance extraction failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading || !!disabledHint}
      title={disabledHint || 'Extract balance sheet account balances'}
      style={{
        background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#8b5cf6'),
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 11,
        cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
        fontWeight: 500
      }}
    >
      {loading ? 'Extracting…' : 'Extract Balances'}
    </button>
  );
}

